import { WoosmapType } from '../types/commons';

export const CUSTOMER_AUTOCOMPLETE_EXCLUDED_TYPES: WoosmapType[] = ['route'];
export const SUPPORTED_WOOSMAP_ADDRESS_TYPE: WoosmapType = 'address';
